import React from 'react';
import PropTypes from 'prop-types';
import { Help } from '@material-ui/icons';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
	toolTipFieldHelp: {
		fontSize: 12,
		lineHeight: 1.6,
		'& .MuiButton-root': {
			textTransform: 'lowercase',
			color: 'white',
			textDecoration: 'underline',
			fontSize: 12,
			padding: 0,
		},
	},
	helpIconStyle: {
		padding: 0,
		marginRight: 5,
		fontSize: 15,
		width: 15,
		height: 15,
		position: 'relative',
		top: 4,
	},
}));

const TooltipFieldHelp = ({ message }) => {
	const classes = useStyles();
	return (
		<span className={`flex-container horizontal start-centered ${classes.toolTipFieldHelp}`}>
			<Help classes={{ root: classes.helpIconStyle }} /> {message}
		</span>
	);
};

TooltipFieldHelp.propTypes = {
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default TooltipFieldHelp;
